import {
  TEAM_AVAILABILITY_GET_REQUEST,
  TEAM_AVAILABILITY_GET_SUCCESS,
  TEAM_AVAILABILITY_GET_FAILURE,
  UPDATE_TIME_LEFT_TO_ALLOCATE,
} from '../../constants/types';
import axios from '../../../utils/axios';

const startRequest = () => ({
  type: TEAM_AVAILABILITY_GET_REQUEST,
});

const errorRequest = error => ({
  type: TEAM_AVAILABILITY_GET_FAILURE,
  error,
});

const successRequest = response => ({
  type: TEAM_AVAILABILITY_GET_SUCCESS,
  response,
});

const successTimeLeftToAlocateRequest = timeleft => ({
  type: UPDATE_TIME_LEFT_TO_ALLOCATE,
  duration: timeleft,
});

export const getTeamAvailability = (teamId, date, jwtToken, timeleft) => async dispatch => {
  const token = `Bearer ${jwtToken}`;
  dispatch(startRequest());

  try {
    const response = await axios({
      url: `v1/query/GetTeamAvailability?teamId=${teamId}&date=${date}`,
      headers: {
        Authorization: token,
      },
    });
    dispatch(successRequest(response));
    dispatch(successTimeLeftToAlocateRequest(timeleft));
  } catch (error) {
    dispatch(errorRequest(error));
  }
};
